<template>
  <div class="spineAnimal">
    <div class="spineAnimal-lg">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3"  border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="物种中文名" prop="chineseName">
          {{ infoContent.chineseName }}
        </el-descriptions-item>
        <el-descriptions-item label="物种学名" prop="scientificName">
          {{ infoContent.scientificName }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="库号" prop="libNum">
          {{ infoContent.libNum }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
        <el-descriptions-item label="采集日期" prop="collectTime">
          {{ infoContent.collectTime }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="DNA条形码片段" prop="stripFragment">
          {{ infoContent.stripFragment }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
          {{ infoContent.createTime }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="spineAnimal-sm">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'" :column="3"  border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="物种中文名" prop="chineseName">
          {{ infoContent.chineseName }}
        </el-descriptions-item>
        <el-descriptions-item label="物种学名" prop="scientificName">
          {{ infoContent.scientificName }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="库号" prop="libNum">
          {{ infoContent.libNum }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
        <el-descriptions-item label="采集日期" prop="collectTime">
          {{ infoContent.collectTime }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="DNA条形码片段" prop="stripFragment">
          {{ infoContent.stripFragment }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
        {{ infoContent.createTime }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>

</template>

<script>
export default {
  name: "spineAnimal",
  props: {
    infoContent: Object,
    title: String
  }
}
</script>

<style scoped lang="scss">
.spineAnimal {
  .spineAnimal-lg {
    display: block;
  }
  .spineAnimal-sm {
    display: none;
  }
}

@media screen and (max-width: 992px) {
  .spineAnimal {
    .spineAnimal-lg {
      display: none;
    }
    .spineAnimal-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .spineAnimal {
    .spineAnimal-lg {
      display: none;
    }
    .spineAnimal-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>